import { CUSTOM_PARAM_SOURCES } from '../constants/enums';
import { getUrlParam } from '../utils';
import { isUrlCp, convertToValues } from '../utils/customParamsUtils';

const CUSTOM_PARAMS_KEY = "usedCustomParams";
const HOSTIING_PARAMS_KEY = "hostingElement";

export function serializeHostingElement(hostingElement) {
  return serializeToUrlParam(HOSTIING_PARAMS_KEY, hostingElement);
}
export function deserializeHostingElementFromUrl() {
  return deserializeFromUrl(HOSTIING_PARAMS_KEY, {})
}
export function serializeCP(customParams) {
  return serializeToUrlParam(CUSTOM_PARAMS_KEY, customParams);
}
export function deserializeCPFromUrl() {
  return deserializeFromUrl(CUSTOM_PARAMS_KEY, [])
}

function serializeToUrlParam(paramName, value) {
  return `${paramName}=${encodeURIComponent(JSON.stringify(value))}`
}
function deserializeFromUrl(paramName, defaultValue) {
  const paramValue = getUrlParam(paramName);
  if (!paramValue || paramValue === "undefined") { return defaultValue; }
  return JSON.parse(decodeURIComponent(paramValue));
}


export function generateCustomParamsString(customParams) {
  let res = "";
  // incorrect input, not an array or missing params  
  if (!Array.isArray(customParams) || !customParams.length) {
    return res;
  }

  //null values are serialized only for cookies
  let valuesToSerialize = convertToValues(customParams.filter(cp => cp.value != null || cp.source.toLowerCase() === CUSTOM_PARAM_SOURCES.COOKIE));
  if (valuesToSerialize.length === 0) return res;

  // build list of params for url - should include name + value only
  res = valuesToSerialize
    .filter(isUrlCp)
    .reduce((accumulator, currentValue) => (currentValue.value != null) ? `${accumulator}&${encodeURIComponent(currentValue.sourceName)}=${encodeURIComponent(currentValue.value)}` : accumulator, "");

  res = `${res}&${serializeCP(valuesToSerialize)}`

  return res;
}

export function reloadPage(data) {
  const {
    formUuid,
    propertyType,
    propertyId,
    customParams,
    urlPrefix,
    hostingElement,
    versionToPresent,
    isShowToggle,
    isDraft,
    shownMode,
    relatedUuid,
    deviceType
  } = data;

  const url = generateLinkQueryString(
    formUuid,
    propertyType,
    propertyId,
    customParams,
    urlPrefix,
    hostingElement,
    versionToPresent,
    isShowToggle,
    isDraft,
    shownMode,
    relatedUuid,
    deviceType
  );

  window.location.href = url;
}

//custom params - only, prefix - depends on specific environment
export function generateLinkQueryString(formUuid, propertyType, propertyId, customParams, prefix, hostingElement, versionToPresent, isShowToggle, isDraft, shownMode, relatedUuid, deviceType) {
  let queryParams = `propertyType=${propertyType}`;
  queryParams += `&propertyId=${propertyId}`;
  queryParams += `&isShowToggle=${isShowToggle}&versionToPresent=${versionToPresent}`;
  queryParams += `&formUuid=${formUuid}`;
  queryParams += '&nebContext=preview';
  queryParams += `${generateCustomParamsString(customParams)}&${serializeHostingElement(hostingElement)}`;
  if (isDraft) {
    queryParams += `&isDraft=${isDraft}`;
  }
  if (shownMode && relatedUuid) {
    queryParams += `&shownMode=${shownMode}&relatedUuid=${relatedUuid}`;
  }
  if (deviceType) {
    queryParams += `&deviceType=${deviceType}`;
  }
  return `${prefix}?${queryParams}`;
}
